import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import Navbar from '../../Pages/Navbar/Navbar';
import Footer from "../../Footer/Footer"
import BaseUrl from '../../ApiServices/BaseUrl';
import GulfWorkerLeadBot from '../../LeadBot/GulfWorkerLeadBot';
import Swal from 'sweetalert2';
import './EuropeanJobs.css';

function EuropeanJobs() {
    const PAGE_SIZE = 15;
    const navigate = useNavigate();
    const user = JSON.parse(localStorage.getItem('user')) || {};
    const [jobs, setJobs] = useState([]);
    const [filteredJobs, setFilteredJobs] = useState([]);
    const [loading, setLoading] = useState(true);
    const [loadingMore, setLoadingMore] = useState(false);
    const [error, setError] = useState(null);
    const [showAllPositions, setShowAllPositions] = useState(false);
    // Mobile responsive states
    const [showFiltersMobile, setShowFiltersMobile] = useState(false);
    const [screenWidth, setScreenWidth] = useState(window.innerWidth);
    const [isMobile, setIsMobile] = useState(window.innerWidth < 992);
    // Track viewed jobs to prevent duplicate counts
    const [viewedJobs, setViewedJobs] = useState([]);
    const [searchInput, setSearchInput] = useState('');
    const [searchTerm, setSearchTerm] = useState('');
    const autoSearchTimeoutRef = useRef(null);
    const isAutoSearchingRef = useRef(false);
    const [page, setPage] = useState(1);
    const [hasMore, setHasMore] = useState(false);
    const [visibleCount, setVisibleCount] = useState(9);

    const getOptimizedImageUrl = (photoPath) => {
        if (!photoPath) return null;
        return `${BaseUrl}${photoPath.replace(/\.(jpg|jpeg|png)$/i, '.webp')}`;
    };

    // Filter states with new structure to match the static UI
    const [activeFilters, setActiveFilters] = useState({
        location: [],
        position: '',
        startDate: '',
        jobType: '',
        contractStatus: [],
        postBy: '',
        language: [],
        skills: []
    });

    const initialFilters = {
        location: [],
        position: '',
        startDate: '',
        jobType: '',
        contractStatus: [],
        postBy: '',
        language: [],
        skills: []
    };

    // Initialize all filter sections as closed by default
    const [showLocation, setShowLocation] = useState(false);
    const [showPosition, setShowPosition] = useState(false);
    const [showStartDate, setShowStartDate] = useState(false);
    const [showJobType, setShowJobType] = useState(false);
    const [showContractStatus, setShowContractStatus] = useState(false);
    const [showPostBy, setShowPostBy] = useState(false);
    const [showLanguage, setShowLanguage] = useState(false);
    const [showSkills, setShowSkills] = useState(false);

    // States for showing more items
    const [showAllLocations, setShowAllLocations] = useState(false);
    const [showAllJobTypes, setShowAllJobTypes] = useState(false);
    const [showAllContractStatuses, setShowAllContractStatuses] = useState(false);
    const [showAllLanguages, setShowAllLanguages] = useState(false);
    const [showAllSkills, setShowAllSkills] = useState(false);

    // Data for filters
    const jobLocations = [
        { id: 'germany', name: 'Germany', icon: 'https://flagcdn.com/w40/de.png' },
        { id: 'united-kingdom', name: 'United Kingdom', icon: 'https://flagcdn.com/w40/gb.png' },
        { id: 'ireland', name: 'Ireland', icon: 'https://flagcdn.com/w40/ie.png' },
        { id: 'croatia', name: 'Croatia', icon: 'https://flagcdn.com/w40/hr.png' },
        { id: 'turkey', name: 'Turkey', icon: 'https://flagcdn.com/w40/tr.png' },
        { id: 'poland', name: 'Poland', icon: 'https://flagcdn.com/w40/pl.png' },
        { id: 'belgium', name: 'Belgium', icon: 'https://flagcdn.com/w40/be.png' },
        { id: 'netherlands', name: 'Netherlands', icon: 'https://flagcdn.com/w40/nl.png' },
        { id: 'france', name: 'France', icon: 'https://flagcdn.com/w40/fr.png' },
        { id: 'italy', name: 'Italy', icon: 'https://flagcdn.com/w40/it.png' },
        { id: 'spain', name: 'Spain', icon: 'https://flagcdn.com/w40/es.png' },
        { id: 'portugal', name: 'Portugal', icon: 'https://flagcdn.com/w40/pt.png' },
        { id: 'romania', name: 'Romania', icon: 'https://flagcdn.com/w40/ro.png' },
        { id: 'hungary', name: 'Hungary', icon: 'https://flagcdn.com/w40/hu.png' },
        { id: 'cyprus', name: 'Cyprus', icon: 'https://flagcdn.com/w40/cy.png' }
    ];


    const jobPositions = [
        { id: 'domestic-helper', name: 'Domestic Helper', icon: 'https://cdn.helperplace.com/icons/maid.svg' },
        { id: 'nanny', name: 'Nanny', icon: 'https://cdn.helperplace.com/icons/nanny.svg' },
        { id: 'cook', name: 'Cook', icon: 'https://cdn.helperplace.com/icons/maid.svg' },
        { id: 'driver', name: 'Driver', icon: 'https://cdn.helperplace.com/icons/driver.svg' },
        { id: 'maid', name: 'Maid', icon: 'https://cdn.helperplace.com/icons/maid.svg' },
        { id: 'nurse', name: 'Nurse', icon: 'https://cdn.helperplace.com/icons/nanny.svg' },
        { id: 'houseboy', name: 'Houseboy', icon: 'https://cdn.helperplace.com/icons/maid.svg' },
        { id: 'tailor', name: 'Tailor', icon: 'https://cdn.helperplace.com/icons/maid.svg' },
        { id: 'teacher', name: 'Teacher', icon: 'https://cdn.helperplace.com/icons/nanny.svg' },
        { id: 'trainer', name: 'Trainer', icon: 'https://cdn.helperplace.com/icons/nanny.svg' },
        { id: 'gardener', name: 'Gardener', icon: 'https://cdn.helperplace.com/icons/maid.svg' },
        { id: 'butler', name: 'Butler', icon: 'https://cdn.helperplace.com/icons/maid.svg' },
        { id: 'housekeeper', name: 'Housekeeper', icon: 'https://cdn.helperplace.com/icons/maid.svg' },
        { id: 'laundry-worker', name: 'Laundry Worker', icon: 'https://cdn.helperplace.com/icons/maid.svg' },
        { id: 'personal-assistant', name: 'Personal Assistant', icon: 'https://cdn.helperplace.com/icons/nanny.svg' },
        { id: 'caregiver', name: 'Caregiver', icon: 'https://cdn.helperplace.com/icons/nanny.svg' },
        { id: 'elder-care-companion', name: 'Elder Care Companion', icon: 'https://cdn.helperplace.com/icons/nanny.svg' },
        { id: 'pet-sitter-dog-walker', name: 'Pet Sitter/Dog Walker', icon: 'https://cdn.helperplace.com/icons/maid.svg' },
        { id: 'house-manager', name: 'House Manager', icon: 'https://cdn.helperplace.com/icons/maid.svg' },
        { id: 'cleaner', name: 'Cleaner', icon: 'https://cdn.helperplace.com/icons/maid.svg' },
        { id: 'maintenance-worker-handyman', name: 'Maintenance Worker/Handyman', icon: 'https://cdn.helperplace.com/icons/maid.svg' },
        { id: 'baby-sitter', name: 'Baby Sitter', icon: 'https://cdn.helperplace.com/icons/nanny.svg' },
        { id: 'tutor', name: 'Tutor', icon: 'https://cdn.helperplace.com/icons/nanny.svg' },
        { id: 'chauffeur', name: 'Chauffeur', icon: 'https://cdn.helperplace.com/icons/driver.svg' },
        { id: 'housemaid', name: 'Housemaid', icon: 'https://cdn.helperplace.com/icons/maid.svg' },
        { id: 'kitchen-staff', name: 'Kitchen Staff', icon: 'https://cdn.helperplace.com/icons/maid.svg' },
        { id: 'dining-room-attendant', name: 'Dining Room Attendant', icon: 'https://cdn.helperplace.com/icons/maid.svg' },
        { id: 'personal-chef', name: 'Personal Chef', icon: 'https://cdn.helperplace.com/icons/maid.svg' },
        { id: 'event-coordinator', name: 'Event Coordinator', icon: 'https://cdn.helperplace.com/icons/maid.svg' },
        { id: 'household-administrator', name: 'Household Administrator', icon: 'https://cdn.helperplace.com/icons/maid.svg' },
        { id: 'domestic-assistant', name: 'Domestic Assistant', icon: 'https://cdn.helperplace.com/icons/maid.svg' }
    ];

    const jobTypes = [
        { id: 'full time', name: 'Full Time', icon: 'https://cdn.helperplace.com/icons/clock.svg' },
        { id: 'part time', name: 'Part Time', icon: 'https://cdn.helperplace.com/icons/time-mgmt.svg' },
        { id: 'temporary', name: 'Temporary', icon: 'https://cdn.helperplace.com/icons/signs.svg' },
        { id: 'permanent', name: 'Permanent', icon: 'https://cdn.helperplace.com/icons/clock.svg' },
        { id: 'internship', name: 'Internship', icon: 'https://cdn.helperplace.com/icons/time-mgmt.svg' },
        { id: 'contractual', name: 'Contractual', icon: 'https://cdn.helperplace.com/icons/clock.svg' },
        { id: 'freelancer', name: 'Freelancer', icon: 'https://cdn.helperplace.com/icons/signs.svg' },
        { id: 'volunteer', name: 'Volunteer', icon: 'https://cdn.helperplace.com/icons/clock.svg' },
        { id: 'fresher', name: 'Fresher', icon: 'https://cdn.helperplace.com/icons/time-mgmt.svg' },
    ];

    const contractStatuses = [
        { id: 'any', name: 'Any' },
        { id: 'contract', name: 'Finshed Contract' },
        { id: 'terminated', name: 'Terminated' },
        { id: 'break contract', name: 'Break Contract' },
        { id: 'transfer', name: 'Transfer' },
        { id: 'Any overseas experience', name: 'Any Overseas Experience' },
        { id: 'resigned', name: 'Resigned' },
    ];

    const postByOptions = [
        { id: 'direct', name: 'Direct' },
        { id: 'agency', name: 'Agency' }
    ];

    const languages = [
        { id: 'english', name: 'English' },
        { id: 'cantonese', name: 'Cantonese' },
        { id: 'mandarin', name: 'Mandarin' },
        { id: 'arabic', name: 'Arabic' },
        { id: 'hindi', name: 'Hindi' },
        { id: 'tagalog', name: 'Tagalog' },
        { id: 'malayali', name: 'Malayali' },
        { id: 'tamil', name: 'Tamil' },
        { id: 'nepali', name: 'Nepali' },
        { id: 'srilankan', name: 'Srilankan' },
        { id: 'japanese', name: 'Japanese' },
        { id: 'russian', name: 'Russian' },
        { id: 'bangali', name: 'Bangladeshi' },
        { id: 'vietnamese', name: 'Vietnamese' },
        { id: 'combodian', name: 'Combodian' },
        { id: 'iranian', name: 'Iranian' },
        { id: 'korean', name: 'Korean' }
    ];

    const mainSkills = [
        { id: 'babycare', name: 'Baby Care' },
        { id: 'childcare', name: 'Child Care' },
        { id: 'teencare', name: 'Teen Care' },
        { id: 'elderly-care', name: 'Elderly Care' },
        { id: 'pet-care', name: 'Pet Care' },
        { id: 'tutoring', name: 'Tutoring' },
        { id: 'cooking', name: 'Cooking' },
        { id: 'house-keeping', name: 'House-Keeping' },
        { id: 'cleaning', name: 'Cleaning' },
        { id: 'marketing', name: 'Marketing' },
        { id: 'grocerias', name: 'Grocerias' }
    ];

    // Dummy profile images array - you can add more if needed
    const dummyProfileImages = [
        'https://cdn-icons-png.flaticon.com/512/3135/3135715.png',
        'https://cdn-icons-png.flaticon.com/512/847/847969.png',
        'https://cdn-icons-png.flaticon.com/512/1077/1077114.png',
        'https://cdn-icons-png.flaticon.com/512/149/149071.png',
        'https://cdn-icons-png.flaticon.com/512/219/219969.png',
        'https://cdn-icons-png.flaticon.com/512/921/921071.png'
    ];

    // Function to get a dummy profile image based on job title or random
    const getDummyProfileImage = (job) => {
        // You can customize this logic based on job properties
        // For now, using a simple hash of job id for consistency
        if (job.id) {
            const index = job.id.toString().split('').reduce((sum, char) => sum + char.charCodeAt(0), 0) % dummyProfileImages.length;
            return dummyProfileImages[index];
        }
        // Return a default dummy image
        return dummyProfileImages[0];
    };

    // Check if employer has Gold subscription
    const hasGoldSubscription = (job) => {
        return (job.effective_plan_type || "").toLowerCase().includes('gold') || 
               (job.effective_plan_name || "").toLowerCase().includes('gold');
    };

    // Check if employer has Silver subscription
    const hasSilverSubscription = (job) => {
        return (job.effective_plan_type || "").toLowerCase().includes('silver') || 
               (job.effective_plan_name || "").toLowerCase().includes('silver');
    };

    const getAgencyPlanBadge = (job) => {
        const planType = (job.effective_plan_type || "").toLowerCase();
        const planName = (job.effective_plan_name || "").toLowerCase();
        
        if (planType.includes('gold') || planName.includes('gold')) {
            return <i className="bi bi-star-fill agency-plan-star gold" title="Gold Plan"></i>;
        }
        if (planType.includes('silver') || planName.includes('silver')) {
            return <i className="bi bi-star-fill agency-plan-star silver" title="Silver Plan"></i>;
        }
        if (planType.includes('pay_per_click') || planType.includes('pay per') || planType.includes('pay-per') || planName.includes('pay per')) {
            return <i className="bi bi-star agency-plan-star hollow" title="Pay Per Use"></i>;
        }
        return null;
    };

    // Handle window resize and initialize desktop filters
    useEffect(() => {
        const checkScreenSize = () => {
            const isDesktop = window.innerWidth >= 992;

            // If desktop, open all filters
            if (isDesktop) {
                setShowLocation(true);
                setShowPosition(true);
                setShowStartDate(true);
                setShowJobType(true);
                setShowContractStatus(true);
                setShowPostBy(true);
                setShowLanguage(true);
                setShowSkills(true);
            } else {
                // If mobile, close all filters
                setShowLocation(false);
                setShowPosition(false);
                setShowStartDate(false);
                setShowJobType(false);
                setShowContractStatus(false);
                setShowPostBy(false);
                setShowLanguage(false);
                setShowSkills(false);
            }
        };

        // Check on initial load
        checkScreenSize();

        // Add resize listener
        window.addEventListener('resize', checkScreenSize);
        return () => window.removeEventListener('resize', checkScreenSize);
    }, []);

    const toggleFilter = (filterType, id) => {
        setActiveFilters((prev) => {
            const currentValues = prev[filterType] || [];
            const newValues = currentValues.includes(id)
                ? currentValues.filter((item) => item !== id)
                : [...currentValues, id];
            return { ...prev, [filterType]: newValues };
        });
    };

    // Function to reset all filters
    const resetAllFilters = () => {
        setActiveFilters(initialFilters);
        setShowAllLocations(false);
        setShowAllJobTypes(false);
        setShowAllContractStatuses(false);
        setShowAllLanguages(false);
        setShowAllSkills(false);
        setShowAllPositions(false);
    };

    const applySearchTerm = async (rawSearchValue) => {
        setSearchTerm(rawSearchValue.trim().toLowerCase());
    };

    const handleSearchSubmit = async (e) => {
        e.preventDefault();
        await applySearchTerm(searchInput);
    };

    const toggleRadioFilter = (filterType, id) => {
        setActiveFilters((prev) => ({
            ...prev,
            [filterType]: prev[filterType] === id ? '' : id
        }));
    };

    const handleJobClick = async (job) => {
        // Check if this user has already viewed this job
        if (!viewedJobs.includes(job.id) && user.id) {
            try {
                // Update view count in backend
                const response = await fetch(`${BaseUrl}/api/employer?temporary_id=${job.id}&user_id=${user.id}`, {
                    method: 'PUT',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        ...job,
                        view_count: job.view_count ? job.view_count + 1 : 1
                    })
                });

                if (response.ok) {
                    // Update the local state to reflect the new view count
                    setJobs(prevJobs =>
                        prevJobs.map(j =>
                            j.id === job.id
                                ? { ...j, view_count: j.view_count ? j.view_count + 1 : 1 }
                                : j
                        )
                    );
                    setFilteredJobs(prevJobs =>
                        prevJobs.map(j =>
                            j.id === job.id
                                ? { ...j, view_count: j.view_count ? j.view_count + 1 : 1 }
                                : j
                        )
                    );

                    // Add this job to viewedJobs to prevent duplicate counts
                    setViewedJobs(prev => [...prev, job.id]);
                }
            } catch (error) {
                console.error('Error updating view count:', error);
            }
        }

        // Navigate to job details
        navigate('/alljobdetails', { state: { job } });
    };

    const handleMessageClick = (job, e) => {
        e.stopPropagation(); // Prevent triggering the job click event

        const user = JSON.parse(localStorage.getItem('user')) || {};

        if (!user.id) {
            Swal.fire({
                title: '<div class="swal-custom-title">Please Register or Login</div>',
                text: 'You must be registered and logged in to message this employer',
                icon: 'info',
                showCancelButton: true,
                showDenyButton: true,
                confirmButtonText: 'Register',
                cancelButtonText: 'Login',
                denyButtonText: '<i class="bi bi-whatsapp"></i> Continue with WhatsApp',
                customClass: {
                    popup: 'registration-popup',
                    confirmButton: 'swal-register-btn',
                    cancelButton: 'swal-login-btn',
                    denyButton: 'swal-whatsapp-btn',
                    actions: 'swal-actions-column'
                },
                buttonsStyling: false,
                showCloseButton: true,
                footer: '<div class="swal-footer-text">Registration helps prevent fake profiles</div>'
            }).then((result) => {
                if (result.isConfirmed) {
                    navigate('/register', {
                        state: { defaultTab: 'jobSeeker' }
                    });
                } else if (result.dismiss === Swal.DismissReason.cancel) {
                    navigate('/login');
                } else if (result.isDenied) {
                    const message = encodeURIComponent('Hello, I want to register on GulfWorker.\nPlease guide me with the registration process');
                    window.open(`https://wa.me/97477651422?text=${message}`, '_blank');
                }
            });
            return;
        }

        // If user is logged in, you can implement the message functionality here
        // For now, show a success message
        Swal.fire({
            icon: 'info',
            title: 'Message Feature',
            text: 'Message functionality will be implemented soon.',
            confirmButtonColor: '#28a745'
        });
    };

    const handleApplyClick = (job, e) => {
        e.stopPropagation(); // Prevent triggering the job click event

        const user = JSON.parse(localStorage.getItem('user')) || {};

        if (!user.id) {
            Swal.fire({
                title: '<div class="swal-custom-title">Please Register or Login</div>',
                text: 'You must be registered and logged in to apply for this job',
                icon: 'info',
                showCancelButton: true,
                showDenyButton: true,
                confirmButtonText: 'Register',
                cancelButtonText: 'Login',
                denyButtonText: '<i class="bi bi-whatsapp"></i> Continue with WhatsApp',
                customClass: {
                    popup: 'registration-popup',
                    confirmButton: 'swal-register-btn',
                    cancelButton: 'swal-login-btn',
                    denyButton: 'swal-whatsapp-btn',
                    actions: 'swal-actions-column'
                },
                buttonsStyling: false,
                showCloseButton: true,
                footer: '<div class="swal-footer-text">Registration helps prevent fake profiles</div>'
            }).then((result) => {
                if (result.isConfirmed) {
                    navigate('/register', {
                        state: { defaultTab: 'jobSeeker' }
                    });
                } else if (result.dismiss === Swal.DismissReason.cancel) {
                    navigate('/login');
                } else if (result.isDenied) {
                    const message = encodeURIComponent('Hello, I want to register on GulfWorker.\nPlease guide me with the registration process');
                    window.open(`https://wa.me/97477651422?text=${message}`, '_blank');
                }
            });
            return;
        }

        // If user is logged in, show success message (following ViewJobs.js pattern)
        Swal.fire({
            icon: 'success',
            title: 'Application Submitted!',
            text: 'Your application has been submitted successfully.',
            confirmButtonColor: '#28a745'
        });
    };

    const formatDate = (dateString) => {
        if (!dateString) return 'N/A';

        try {
            // Handle different date formats
            let date;

            if (dateString.includes('T')) {
                // ISO format with T (e.g., "2025-09-03T15:00:00.000Z")
                date = new Date(dateString);
            } else if (dateString.includes(' ')) {
                // Datetime format without T (e.g., "2025-09-03 15:00:00")
                // Replace space with T to convert to ISO-like format
                date = new Date(dateString.replace(' ', 'T'));
            } else {
                // Date only format (e.g., "2025-09-03")
                date = new Date(dateString + 'T00:00:00');
            }

            // Check if date is valid
            if (isNaN(date.getTime())) {
                return 'N/A';
            }

            return date.toLocaleDateString('en-GB', {
                day: '2-digit',
                month: 'short',
                year: 'numeric'
            });
        } catch (e) {
            console.error('Error formatting date:', e);
            return 'N/A';
        }
    };

    const safeParseArray = (field) => {
        if (Array.isArray(field)) return field;
        if (typeof field === 'string') {
            try {
                const parsed = JSON.parse(field.replace(/\\"/g, '"'));
                return Array.isArray(parsed) ? parsed : [];
            } catch {
                return [];
            }
        }
        return [];
    };

    // Handle window resize
    useEffect(() => {
        const checkScreenSize = () => {
            const mobile = window.innerWidth < 992;
            setIsMobile(mobile);

            // If desktop, open all filters
            if (!mobile) {
                setShowLocation(true);
                setShowPosition(true);
                setShowStartDate(true);
                setShowJobType(true);
                setShowContractStatus(true);
                setShowPostBy(true);
                setShowLanguage(true);
                setShowSkills(true);
                setShowFiltersMobile(true); // Show filters on desktop
            } else {
                // If mobile, close all filters
                setShowLocation(false);
                setShowPosition(false);
                setShowStartDate(false);
                setShowJobType(false);
                setShowContractStatus(false);
                setShowPostBy(false);
                setShowLanguage(false);
                setShowSkills(false);
                setShowFiltersMobile(false); // Hide filters on mobile
            }
        };

        // Check on initial load
        checkScreenSize();

        // Add resize listener
        window.addEventListener('resize', checkScreenSize);
        return () => window.removeEventListener('resize', checkScreenSize);
    }, []);

    // useEffect(() => {
    //   const fetchJobs = async () => {
    //     try {
    //       // Fetch both jobs and users data
    //       const [jobsResponse, usersResponse] = await Promise.all([
    //         fetch(`${BaseUrl}/api/employer/all`),
    //         fetch(`${BaseUrl}/`) // Adjust this endpoint if needed
    //       ]);

    //       if (!jobsResponse.ok) {
    //         throw new Error('Failed to fetch jobs');
    //       }
    //       if (!usersResponse.ok) {
    //         throw new Error('Failed to fetch users');
    //       }

    //       let jobsData = await jobsResponse.json();
    //       const usersData = await usersResponse.json();

    //       const currentDate = new Date().toISOString().split('T')[0]; // YYYY-MM-DD

    //       // Create a map of users for easy lookup
    //       const usersMap = {};
    //       usersData.forEach(user => {
    //         usersMap[user.id] = user;
    //       });

    //       // Filter approved jobs and check subscription from users table
    //       jobsData = jobsData.filter(job => {
    //         // Check if job is approved
    //         if (job.status !== 'Approved') return false;

    //         // Find the corresponding user for this job
    //         const user = usersMap[job.user_id];
    //         if (!user) return false;

    //         // Check if user has valid subscription dates
    //         const userPlanEndDate = user.plan_enddate;
    //         if (!userPlanEndDate) return false;

    //         return new Date(userPlanEndDate) >= new Date(currentDate);
    //       });

    //       // Priority mapping (lower number = higher priority)
    //       const priorityMap = {
    //         'gold': 1,
    //         'free posting': 1,
    //         'silver': 2
    //       };

    //       // Helper: normalize plan name
    //       const normalizePlan = (planName = '') => (planName || '').toString().trim().toLowerCase();

    //       // Helper: get numeric timestamp for job's posting date
    //       const getJobTimestamp = (job) => {
    //         const candidates = [
    //           job.createdAt,
    //           job.created_at,
    //           job.job_posted_date,
    //           job.posted_at,
    //           job.createdOn,
    //           job.postedDate,
    //           job.posted_date
    //         ];

    //         for (const val of candidates) {
    //           if (!val) continue;
    //           const ts = new Date(val).getTime();
    //           if (!isNaN(ts)) return ts;
    //         }

    //         if (typeof job.created_timestamp === 'number' && !isNaN(job.created_timestamp)) {
    //           return job.created_timestamp;
    //         }

    //         if (job.plan_startdate) {
    //           const ts = new Date(job.plan_startdate).getTime();
    //           if (!isNaN(ts)) return ts;
    //         }

    //         return 0;
    //       };

    //       // Sort by plan priority first, then by posting date
    //       jobsData.sort((a, b) => {
    //         const planA = normalizePlan(a.plan_name);
    //         const planB = normalizePlan(b.plan_name);

    //         const priorityA = priorityMap[planA] ?? (planA.includes('free') ? 1 : 3);
    //         const priorityB = priorityMap[planB] ?? (planB.includes('free') ? 1 : 3);

    //         if (priorityA !== priorityB) {
    //           return priorityA - priorityB;
    //         }

    //         const tsA = getJobTimestamp(a);
    //         const tsB = getJobTimestamp(b);

    //         return tsB - tsA;
    //       });

    //       // Safely parse stringified arrays and prepare profile photo URL
    //       jobsData = jobsData.map(job => ({
    //         ...job,
    //         preferred_candidates_country: safeParseArray(job.preferred_candidates_country),
    //         candidates_country_experience: safeParseArray(job.candidates_country_experience),
    //         main_skills: safeParseArray(job.main_skills),
    //         cooking_skills: safeParseArray(job.cooking_skills),
    //         other_skills: safeParseArray(job.other_skills),
    //         preferred_years_of_experience: safeParseArray(job.preferred_years_of_experience),
    //         offer_for_selected_candidates: safeParseArray(job.offer_for_selected_candidates),
    //         preferred_language_for_worker: safeParseArray(job.preferred_language_for_worker),
    //         profile_photo_url: job.profile_photo ? `${BaseUrl}${job.profile_photo}` : null,
    //         // Add dummy profile image if no image is available
    //         dummy_profile_image: getDummyProfileImage(job),
    //         // Add user subscription info to job object for easy access
    //         user_subscription: usersMap[job.user_id] ? {
    //           plan_startdate: usersMap[job.user_id].plan_startdate,
    //           plan_enddate: usersMap[job.user_id].plan_enddate,
    //           plan_name: usersMap[job.user_id].plan_name
    //         } : null
    //       }));

    //       setJobs(jobsData);
    //       setFilteredJobs(jobsData);
    //     } catch (err) {
    //       setError(err.message);
    //     } finally {
    //       setLoading(false);
    //     }
    //   };

    //   fetchJobs();
    // }, []);

    // Apply filters whenever filter criteria change

    const fetchJobsPage = async (pageNumber) => {
        const response = await fetch(`${BaseUrl}/api/employer/all?paginated=1&segment=europe&page=${pageNumber}&limit=${PAGE_SIZE}`);
        if (!response.ok) throw new Error('Failed to fetch jobs');
        
        let jobsData = await response.json();
        const paginatedPayload = jobsData;
        if (!Array.isArray(jobsData)) {
            if (jobsData.data && Array.isArray(jobsData.data)) jobsData = jobsData.data;
            else jobsData = [];
        }

        // Filter and sort
        jobsData = jobsData.filter(isApprovedEuropeanJob);
        
        // Priority mapping
        const priorityMap = { 'gold': 1, 'free posting': 1, 'silver': 2 };
        const normalizePlan = (planName = '') => (planName || '').toString().trim().toLowerCase();
        
        jobsData.sort((a, b) => {
            const planA = normalizePlan(a.effective_plan_type || a.effective_plan_name);
            const planB = normalizePlan(b.effective_plan_type || b.effective_plan_name);
            const priorityA = priorityMap[planA] ?? (planA.includes('free') ? 1 : 3);
            const priorityB = priorityMap[planB] ?? (planB.includes('free') ? 1 : 3);
            return priorityA !== priorityB ? priorityA - priorityB : 0;
        });

        // Format
        jobsData = jobsData.map(job => ({
            ...job,
            preferred_candidates_country: safeParseArray(job.preferred_candidates_country),
            candidates_country_experience: safeParseArray(job.candidates_country_experience),
            main_skills: safeParseArray(job.main_skills),
            cooking_skills: safeParseArray(job.cooking_skills),
            other_skills: safeParseArray(job.other_skills),
            preferred_years_of_experience: safeParseArray(job.preferred_years_of_experience),
            offer_for_selected_candidates: safeParseArray(job.offer_for_selected_candidates),
            preferred_language_for_worker: safeParseArray(job.preferred_language_for_worker),
            profile_photo_url: job.profile_photo ? `${BaseUrl}${job.profile_photo}` : null,
            dummy_profile_image: getDummyProfileImage(job),
            user_subscription: {
                plan_startdate: job.effective_plan_startdate,
                plan_enddate: job.effective_plan_enddate,
                plan_name: job.effective_plan_name
            }
        }));

        return { data: jobsData, hasMore: Boolean(paginatedPayload?.hasMore) };
    };

    const isApprovedEuropeanJob = (job) => {
        if (!job) return false;
        if (job.status !== 'Approved') return false;
        const europeanCountries = [
            'germany', 'united kingdom', 'uk', 'ireland', 'croatia', 
            'turkey', 'poland', 'belgium', 'netherlands', 'france', 
            'italy', 'spain', 'portugal', 'romania', 'hungary', 'cyprus'
        ];
        const jobCountry = (job.country || '').toLowerCase().trim();
        if (!jobCountry) return false;
        return europeanCountries.some(country => 
            jobCountry.includes(country) || country.includes(jobCountry)
        );
    };

    useEffect(() => {
        const initialFetch = async () => {
            try {
                let { data: currentJobs, hasMore: currentHasMore } = await fetchJobsPage(1);
                let currentPage = 1;

                while (currentJobs.length < 9 && currentHasMore) {
                    currentPage++;
                    const result = await fetchJobsPage(currentPage);
                    currentJobs = [...currentJobs, ...result.data];
                    currentHasMore = result.hasMore;
                }

                setJobs(currentJobs);
                setFilteredJobs(currentJobs);
                setPage(currentPage);
                setHasMore(currentHasMore);
            } catch (err) {
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };
        initialFetch();
    }, []);

    const handleLoadMore = async () => {
        const nextVisible = visibleCount + 9;
        setVisibleCount(nextVisible);

        if (nextVisible >= filteredJobs.length && hasMore && !loadingMore) {
            try {
                setLoadingMore(true);
                let currentJobs = [...jobs];
                let currentHasMore = hasMore;
                let currentPage = page;

                while (currentHasMore && currentJobs.filter(isApprovedEuropeanJob).length < nextVisible) {
                    const result = await fetchJobsPage(currentPage + 1);
                    currentHasMore = result.hasMore;
                    currentPage++;
                    currentJobs = [...currentJobs, ...result.data];
                }

                setJobs(currentJobs);
                setPage(currentPage);
                setHasMore(currentHasMore);
            } catch (err) {
                setError(err.message);
            } finally {
                setLoadingMore(false);
            }
        }
    };

    useEffect(() => {
        if (autoSearchTimeoutRef.current) {
            clearTimeout(autoSearchTimeoutRef.current);
        }

        autoSearchTimeoutRef.current = setTimeout(async () => {
            if (isAutoSearchingRef.current) return;

            const normalizedSearchInput = searchInput.trim().toLowerCase();
            if (normalizedSearchInput === searchTerm) return;

            isAutoSearchingRef.current = true;
            try {
                await applySearchTerm(searchInput);
            } finally {
                isAutoSearchingRef.current = false;
            }
        }, 350);

        return () => {
            if (autoSearchTimeoutRef.current) {
                clearTimeout(autoSearchTimeoutRef.current);
            }
        };
    }, [searchInput, searchTerm]);


    useEffect(() => {
        let result = [...jobs];

        // Filter by job position
        if (activeFilters.position) {
            result = result.filter(job => {
                const category = job.domestic_worker_category?.toLowerCase();
                return (activeFilters.position === 'domestic-helper' && category?.includes('domestic helper')) ||
                    (activeFilters.position === 'nanny' && category?.includes('nanny')) ||
                    (activeFilters.position === 'cook' && category?.includes('cook')) ||
                    (activeFilters.position === 'driver' && category?.includes('driver'));
            });
        }

        // Filter by location
        if (activeFilters.location.length > 0) {
            result = result.filter(job => {
                const jobCountry = (job.country || '').toLowerCase().trim();
                return activeFilters.location.some(locationId => {
                    const location = jobLocations.find(loc => loc.id === locationId);
                    if (!location) return false;

                    return jobCountry.includes(location.name.toLowerCase()) || location.name.toLowerCase().includes(jobCountry);
                });
            });
        }

        // Filter by job type
        if (activeFilters.jobType) {
            const selectedType = activeFilters.jobType.toLowerCase().replace(/[-\s]/g, '');

            result = result.filter(job => {
                const type = job.job_type?.toLowerCase().replace(/[-\s]/g, '');
                return type?.includes(selectedType);
            });
        }

        // Filter by contract status
        if (activeFilters.contractStatus.length > 0) {
            result = result.filter(job => {
                const status = job.contract_status?.toLowerCase();
                return activeFilters.contractStatus.some(contractStatus =>
                    status?.includes(contractStatus)
                );
            });
        }

        // Filter by posted by
        if (activeFilters.postBy) {
            result = result.filter(job => {
                const type = job.posted_by?.toLowerCase();
                return type?.includes(activeFilters.postBy.toLowerCase());
            });
        }

        // Filter by language
        if (activeFilters.language.length > 0) {
            result = result.filter(job => {
                const langs = job.preferred_language_for_worker?.join(' ').toLowerCase() || '';
                return activeFilters.language.some(lang => {
                    const language = languages.find(l => l.id === lang);
                    return language && langs.includes(language.name.toLowerCase());
                });
            });
        }

        // Filter by main skills
        if (activeFilters.skills.length > 0) {
            result = result.filter(job => {
                const skills = job.main_skills?.join(' ').toLowerCase() || '';
                return activeFilters.skills.some(skillId => {
                    const skill = mainSkills.find(s => s.id === skillId);
                    return skill && skills.includes(skill.name.toLowerCase());
                });
            });
        }

        // Filter by start date
        if (activeFilters.startDate) {
            try {
                const selectedDate = new Date(activeFilters.startDate);
                selectedDate.setHours(0, 0, 0, 0);

                result = result.filter(job => {
                    if (!job.job_starting_date) return false;

                    try {
                        const jobDate = new Date(job.job_starting_date);
                        jobDate.setHours(0, 0, 0, 0);
                        return jobDate >= selectedDate;
                    } catch (e) {
                        console.error('Error parsing job date:', job.job_starting_date, e);
                        return false;
                    }
                });
            } catch (e) {
                console.error('Error parsing selected date:', activeFilters.startDate, e);
            }
        }

        if (searchTerm) {
            const term = searchTerm.toLowerCase();
            result = result.filter(job => {
                const title = job.job_title?.toLowerCase() || '';
                const country = job.country?.toLowerCase() || '';
                const city = job.working_city?.toLowerCase() || '';
                const state = job.state_or_province?.toLowerCase() || '';
                const category = job.domestic_worker_category?.toLowerCase() || '';
                const jobType = job.job_type?.toLowerCase() || '';
                return (
                    title.includes(term) ||
                    country.includes(term) ||
                    city.includes(term) ||
                    state.includes(term) ||
                    category.includes(term) ||
                    jobType.includes(term)
                );
            });
        }

        setFilteredJobs(result);
    }, [jobs, activeFilters, searchTerm]);

    // Reset visible count only when user changes filters
    useEffect(() => {
        setVisibleCount(9);
    }, [activeFilters, searchTerm]);

    if (loading) {
        return (
            <>
                <Navbar />
                <div className="container-fluid joblisting-wrapper py-4">
                    <div className="text-center">Loading jobs...</div>
                </div>
            </>
        );
    }

    if (error) {
        return (
            <>
                <Navbar />
                <div className="container-fluid joblisting-wrapper py-4">
                    <div className="text-center text-danger">Error: {error}</div>
                </div>
            </>
        );
    }

    return (
        <>
            <Navbar />
            <div className="container-fluid joblisting-wrapper py-4" style={{ marginTop: '80px' }}>
                <div className="row">
                    {/* Sidebar Filter */}
                    {/* Mobile Filter Toggle Button */}
                    {isMobile && (
                        <div className="mb-3">
                            <button
                                className="btn btn-primary w-100"
                                onClick={() => setShowFiltersMobile(!showFiltersMobile)}
                            >
                                <i className="bi bi-funnel me-2"></i>
                                {showFiltersMobile ? 'Hide Filters' : 'Show Filters'}
                            </button>
                        </div>
                    )}
                    {(showFiltersMobile || !isMobile) && (
                        <div className="col-lg-3">
                            <div className="filters p-3 mb-2 border rounded bg-light">
                                {/* Filter Header with Refresh Button */}
                                <div className="d-flex justify-content-between align-items-center mb-4">
                                    <h5 className="mb-0">Filters</h5>
                                    <button
                                        className="btn btn-sm btn-outline-secondary"
                                        onClick={resetAllFilters}
                                        title="Reset all filters"
                                    >
                                        <i className="bi bi-arrow-clockwise"></i> Reset
                                    </button>
                                </div>

                                {/* Location Filter */}
                                <div className="mb-2 filter-section">
                                    <div
                                        className="d-flex justify-content-between align-items-center cursor-pointer mb-2 filter-header"
                                        onClick={() => setShowLocation(!showLocation)}
                                    >
                                        <strong>Job Location</strong>
                                        <i className={`bi ${showLocation ? 'bi-chevron-down' : 'bi-chevron-right'}`}></i>
                                    </div>
                                    {showLocation && (
                                        <div className="filter-content">
                                            <div className="d-flex flex-column gap-2">
                                                {jobLocations.slice(0, showAllLocations ? jobLocations.length : 5).map((loc) => (
                                                    <div key={loc.id} className="form-check">
                                                        <input
                                                            className="form-check-input"
                                                            type="checkbox"
                                                            id={`location-${loc.id}`}
                                                            checked={activeFilters.location.includes(loc.id)}
                                                            onChange={() => toggleFilter('location', loc.id)}
                                                        />
                                                        <label className="form-check-label d-flex align-items-center" htmlFor={`location-${loc.id}`}>
                                                            {loc.icon && <img src={loc.icon} alt={loc.name} width="20" height="20" className="me-2" />}
                                                            {loc.name}
                                                        </label>
                                                    </div>
                                                ))}
                                                {jobLocations.length > 5 && (
                                                    <button
                                                        className="btn btn-link p-0 text-decoration-none text-primary" style={{ textAlign: 'left' }}
                                                        onClick={() => setShowAllLocations(!showAllLocations)}
                                                    >
                                                        {showAllLocations ? 'Show Less' : 'Show More'}
                                                    </button>
                                                )}
                                            </div>
                                        </div>
                                    )}
                                </div>

                                {/* Job Position Filter */}
                                <div className="mb-4 filter-section">
                                    <div
                                        className="d-flex justify-content-between align-items-center cursor-pointer mb-2 filter-header"
                                        onClick={() => setShowPosition(!showPosition)}
                                    >
                                        <strong>Job Position</strong>
                                        <i className={`bi ${showPosition ? 'bi-chevron-down' : 'bi-chevron-right'}`}></i>
                                    </div>
                                    {showPosition && (
                                        <div className="filter-content">
                                            <div className="d-flex flex-column gap-2">
                                                {jobPositions
                                                    .slice(0, showAllPositions ? jobPositions.length : 5)
                                                    .map((pos) => (
                                                        <div key={pos.id} className="form-check">
                                                            <input
                                                                className="form-check-input"
                                                                type="radio"
                                                                name="jobPosition"
                                                                id={`position-${pos.id}`}
                                                                checked={activeFilters.position === pos.id}
                                                                onChange={() => toggleRadioFilter('position', pos.id)}
                                                            />
                                                            <label
                                                                className="form-check-label d-flex align-items-center"
                                                                htmlFor={`position-${pos.id}`}
                                                            >
                                                                {pos.icon && (
                                                                    <img
                                                                        src={pos.icon}
                                                                        alt={pos.name}
                                                                        width="20"
                                                                        height="20"
                                                                        className="me-2"
                                                                    />
                                                                )}
                                                                {pos.name}
                                                            </label>
                                                        </div>
                                                    ))}

                                                {jobPositions.length > 5 && (
                                                    <button
                                                        className="btn btn-link p-0 text-decoration-none text-primary" style={{ textAlign: 'left' }}
                                                        onClick={() => setShowAllPositions(!showAllPositions)}
                                                    >
                                                        {showAllPositions ? 'Show Less' : 'Show More'}
                                                    </button>
                                                )}
                                            </div>
                                        </div>
                                    )}
                                </div>

                                {/* Start Date Filter */}
                                <div className="mb-4 filter-section">
                                    <div
                                        className="d-flex justify-content-between align-items-center cursor-pointer mb-2 filter-header"
                                        onClick={() => setShowStartDate(!showStartDate)}
                                    >
                                        <strong>Start Date</strong>
                                        <i className={`bi ${showStartDate ? 'bi-chevron-down' : 'bi-chevron-right'}`}></i>
                                    </div>
                                    {showStartDate && (
                                        <div className="filter-content">
                                            <div className="p-2 bg-white rounded border">
                                                <input
                                                    type="date"
                                                    className="form-control"
                                                    value={activeFilters.startDate}
                                                    onChange={(e) => setActiveFilters({ ...activeFilters, startDate: e.target.value })}
                                                />
                                            </div>
                                        </div>
                                    )}
                                </div>

                                {/* Job Type Filter */}
                                <div className="mb-4 filter-section">
                                    <div
                                        className="d-flex justify-content-between align-items-center cursor-pointer mb-2 filter-header"
                                        onClick={() => setShowJobType(!showJobType)}
                                    >
                                        <strong>Job Type</strong>
                                        <i className={`bi ${showJobType ? 'bi-chevron-down' : 'bi-chevron-right'}`}></i>
                                    </div>
                                    {showJobType && (
                                        <div className="filter-content">
                                            <div className="d-flex flex-column gap-2">
                                                {jobTypes.slice(0, showAllJobTypes ? jobTypes.length : 5).map((type) => (
                                                    <div key={type.id} className="form-check">
                                                        <input
                                                            className="form-check-input"
                                                            type="radio"
                                                            name="jobType"
                                                            id={`type-${type.id}`}
                                                            checked={activeFilters.jobType === type.id}
                                                            onChange={() => toggleRadioFilter('jobType', type.id)}
                                                        />
                                                        <label className="form-check-label d-flex align-items-center" htmlFor={`type-${type.id}`}>
                                                            {type.icon && <img src={type.icon} alt={type.name} width="20" height="20" className="me-2" />}
                                                            {type.name}
                                                        </label>
                                                    </div>
                                                ))}
                                                {jobTypes.length > 5 && (
                                                    <button
                                                        className="btn btn-link p-0 text-decoration-none text-primary" style={{ textAlign: 'left' }}
                                                        onClick={() => setShowAllJobTypes(!showAllJobTypes)}
                                                    >
                                                        {showAllJobTypes ? 'Show Less' : 'Show More'}
                                                    </button>
                                                )}
                                            </div>
                                        </div>
                                    )}
                                </div>

                                {/* Contract Status Filter */}
                                <div className="mb-4 filter-section">
                                    <div
                                        className="d-flex justify-content-between align-items-center cursor-pointer mb-2 filter-header"
                                        onClick={() => setShowContractStatus(!showContractStatus)}
                                    >
                                        <strong>Contract Status</strong>
                                        <i className={`bi ${showContractStatus ? 'bi-chevron-down' : 'bi-chevron-right'}`}></i>
                                    </div>
                                    {showContractStatus && (
                                        <div className="filter-content">
                                            <div className="d-flex flex-column gap-2">
                                                {contractStatuses.slice(0, showAllContractStatuses ? contractStatuses.length : 5).map((status) => (
                                                    <div key={status.id} className="form-check">
                                                        <input
                                                            className="form-check-input"
                                                            type="checkbox"
                                                            id={`status-${status.id}`}
                                                            checked={activeFilters.contractStatus.includes(status.id)}
                                                            onChange={() => toggleFilter('contractStatus', status.id)}
                                                        />
                                                        <label className="form-check-label" htmlFor={`status-${status.id}`}>
                                                            {status.name}
                                                        </label>
                                                    </div>
                                                ))}
                                                {contractStatuses.length > 5 && (
                                                    <button
                                                        className="btn btn-link p-0 text-decoration-none text-primary" style={{ textAlign: 'left' }}
                                                        onClick={() => setShowAllContractStatuses(!showAllContractStatuses)}
                                                    >
                                                        {showAllContractStatuses ? 'Show Less' : 'Show More'}
                                                    </button>
                                                )}
                                            </div>
                                        </div>
                                    )}
                                </div>

                                {/* Post By Filter */}
                                <div className="mb-4 filter-section">
                                    <div
                                        className="d-flex justify-content-between align-items-center cursor-pointer mb-2 filter-header"
                                        onClick={() => setShowPostBy(!showPostBy)}
                                    >
                                        <strong>Post By</strong>
                                        <i className={`bi ${showPostBy ? 'bi-chevron-down' : 'bi-chevron-right'}`}></i>
                                    </div>
                                    {showPostBy && (
                                        <div className="filter-content">
                                            <div className="d-flex flex-column gap-2">
                                                {postByOptions.map((option) => (
                                                    <div key={option.id} className="form-check">
                                                        <input
                                                            className="form-check-input"
                                                            type="radio"
                                                            name="postBy"
                                                            id={`postby-${option.id}`}
                                                            checked={activeFilters.postBy === option.id}
                                                            onChange={() => toggleRadioFilter('postBy', option.id)}
                                                        />
                                                        <label className="form-check-label" htmlFor={`postby-${option.id}`}>
                                                            {option.name}
                                                        </label>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    )}
                                </div>

                                {/* Language Filter */}
                                <div className="mb-4 filter-section">
                                    <div
                                        className="d-flex justify-content-between align-items-center cursor-pointer mb-2 filter-header"
                                        onClick={() => setShowLanguage(!showLanguage)}
                                    >
                                        <strong>Language</strong>
                                        <i className={`bi ${showLanguage ? 'bi-chevron-down' : 'bi-chevron-right'}`}></i>
                                    </div>
                                    {showLanguage && (
                                        <div className="filter-content">
                                            <div className="d-flex flex-column gap-2">
                                                {languages.slice(0, showAllLanguages ? languages.length : 5).map((lang) => (
                                                    <div key={lang.id} className="form-check">
                                                        <input
                                                            className="form-check-input"
                                                            type="checkbox"
                                                            id={`lang-${lang.id}`}
                                                            checked={activeFilters.language.includes(lang.id)}
                                                            onChange={() => toggleFilter('language', lang.id)}
                                                        />
                                                        <label className="form-check-label" htmlFor={`lang-${lang.id}`}>
                                                            {lang.name}
                                                        </label>
                                                    </div>
                                                ))}
                                                {languages.length > 5 && (
                                                    <button
                                                        className="btn btn-link p-0 text-decoration-none text-primary" style={{ textAlign: 'left' }}
                                                        onClick={() => setShowAllLanguages(!showAllLanguages)}
                                                    >
                                                        {showAllLanguages ? 'Show Less' : 'Show More'}
                                                    </button>
                                                )}
                                            </div>
                                        </div>
                                    )}
                                </div>

                                {/* Main Skills Filter */}
                                <div className="mb-4 filter-section">
                                    <div
                                        className="d-flex justify-content-between align-items-center cursor-pointer mb-2 filter-header"
                                        onClick={() => setShowSkills(!showSkills)}
                                    >
                                        <strong>Main Skills</strong>
                                        <i className={`bi ${showSkills ? 'bi-chevron-down' : 'bi-chevron-right'}`}></i>
                                    </div>
                                    {showSkills && (
                                        <div className="filter-content">
                                            <div className="d-flex flex-column gap-2">
                                                {mainSkills.slice(0, showAllSkills ? mainSkills.length : 5).map((skill) => (
                                                    <div key={skill.id} className="form-check">
                                                        <input
                                                            className="form-check-input"
                                                            type="checkbox"
                                                            id={`skill-${skill.id}`}
                                                            checked={activeFilters.skills.includes(skill.id)}
                                                            onChange={() => toggleFilter('skills', skill.id)}
                                                        />
                                                        <label className="form-check-label" htmlFor={`skill-${skill.id}`}>
                                                            {skill.name}
                                                        </label>
                                                    </div>
                                                ))}
                                                {mainSkills.length > 5 && (
                                                    <button
                                                        className="btn btn-link p-0 text-decoration-none text-primary" style={{ textAlign: 'left' }}
                                                        onClick={() => setShowAllSkills(!showAllSkills)}
                                                    >
                                                        {showAllSkills ? 'Show Less' : 'Show More'}
                                                    </button>
                                                )}
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    )}
                    {/* Job Listings */}
                    <div className={isMobile ? "col-12" : "col-lg-9"}>
                        <form className="mb-3" onSubmit={handleSearchSubmit}>
                            <div className="input-group w-100">
                                <input
                                    type="text"
                                    className="form-control job-search-input"
                                    placeholder="Search by job title, location, or category"
                                    value={searchInput}
                                    onChange={(e) => setSearchInput(e.target.value)}
                                    style={{ minWidth: 0, height: '38px' }}
                                />
                                <button
                                    type="submit"
                                    className="btn btn-primary px-3"
                                    style={{ whiteSpace: 'nowrap', flexShrink: 0, minWidth: '78px', height: '38px' }}
                                >
                                    Search
                                </button>
                            </div>
                        </form>
                        {filteredJobs.length === 0 ? (
                            <div className="text-center no-jobs-message">No jobs match your filters</div>
                        ) : (
                            <>
                            <div className="row">
                                {filteredJobs.slice(0, visibleCount).map((job) => (
                                    <div key={job.id} className="col-md-12 mb-4">
                                        <div
                                            className="jobcard-wrapper-viewjobs d-flex p-3 shadow-sm rounded"
                                            onClick={() => handleJobClick(job)}
                                            style={{ cursor: 'pointer' }}
                                        >

                                            {/* Image Section */}
                                            <div className="jobcard-image text-center" style={{ width: '18%', flexShrink: 0 }}>
                                                <img
                                                    src={job.profile_photo_url || job.dummy_profile_image}
                          loading="lazy"
                                                    alt={job.job_title}
                                                    className="img-fluid rounded-circle jobcard-avatar-eviewjobs mb-2 viewjob-image-viewjob"
                                                    onError={(e) => {
                                                        // If image fails to load, use dummy profile image
                                                        e.target.src = job.dummy_profile_image || dummyProfileImages[0];
                                                    }}
                                                />

                                                {/* Stars and Employer text side by side */}
                                                <div className="d-flex justify-content-center align-items-center mb-1">
                                                    {/* Stars on left side */}
                                                    <div className="me-2">
                                                        {!job.posted_by?.toLowerCase().includes('direct') ? (
                                                            getAgencyPlanBadge(job)
                                                        ) : null}
                                                        {job.posted_by?.toLowerCase().includes('direct') && hasGoldSubscription(job) && (
                                                            <span className="star-icon" title="Gold Subscription Employer">
                                                                <i className="bi bi-star-fill text-warning"></i>
                                                            </span>
                                                        )}
                                                        {job.posted_by?.toLowerCase().includes('direct') && hasSilverSubscription(job) && (
                                                            <span className="star-icon" title="Silver Subscription Employer">
                                                                <i className="bi bi-star-fill text-secondary"></i>
                                                            </span>
                                                        )}
                                                    </div>

                                                    {/* Employer text on right side */}
                                                    <div className="jobcard-label-text mb-0">
                                                        {job.posted_by?.toLowerCase().includes('direct') ? 'Employer' : 'Agency'}
                                                    </div>
                                                </div>
                                            </div>

                                            {/* Content Section */}
                                            <div className="jobcard-content ms-3" style={{ width: '70%' }}>
                                                <div className="jobcard-title-container mb-2">
                                                    <h6 className="jobcard-title-viewalljobs mb-0">
                                                        {job.job_title}
                                                    </h6>
                                                    {/* Gold and Silver Stars - Properly aligned container */}
                                                    <div className="jobcard-stars-container">
                                                        {hasGoldSubscription(job) && (
                                                            <span className="star-icon" title="Gold Subscription Employer">
                                                                {/* <i className="bi bi-star-fill text-warning"></i> */}
                                                            </span>
                                                        )}
                                                        {hasSilverSubscription(job) && (
                                                            <span className="star-icon" title="Silver Subscription Employer">
                                                                {/* <i className="bi bi-star-fill text-secondary"></i> */}
                                                            </span>
                                                        )}
                                                    </div>
                                                </div>
                                                <div className="jobcard-family text-muted mb-1">
                                                    {(() => {
                                                        const parts = [];
                                                        if (job.adults) parts.push(`${job.adults} adults`);
                                                        if (job.children) parts.push(`${job.children} kids`);
                                                        return parts.join(' + ');
                                                    })()}
                                                </div>
                                                <div className="jobcard-location-alljobs text-muted mb-1">
                                                    <i className="bi bi-geo-alt-fill me-1"></i>
                                                    {[
                                                        job.working_city,
                                                        job.state_or_province,
                                                        job.country
                                                    ].filter(Boolean).join(', ')}
                                                </div>
                                                {/* Job Description - Hidden on mobile, visible on desktop */}
                                                <div className="viewjobs-jobcard-description text-muted mb-4">
                                                    {job.job_description || 'No description available'}
                                                </div>
                                                <div className="d-flex jobcard-location-alljobs flex-wrap gap-1 small mt-1 align-items-center">
                                                    <div className="text-muted">
                                                        <i className="bi bi-person-fill me-1"></i>
                                                        {job.domestic_worker_category || 'N/A'} | {job.job_type || 'N/A'}
                                                    </div>
                                                    <div className="text-muted joiningdate-alljobs-fontsize">
                                                        <i className="bi bi-calendar-event me-1"></i>
                                                        <strong>Joining Date:</strong>&nbsp;
                                                        {
                                                            job.job_starting_date &&
                                                                (job.job_starting_date.toString().toLowerCase().includes('immediate') ||
                                                                    job.job_starting_date.toString().toLowerCase().includes('asap') ||
                                                                    job.job_starting_date.toString().toLowerCase().includes('soon') ||
                                                                    job.job_starting_date.toString().toLowerCase().includes('urgent'))
                                                                ? job.job_starting_date
                                                                : formatDate(job.job_starting_date)
                                                        }
                                                    </div>
                                                    {/* <div className="text-success fw-semibold jobcard-location-alljobs">
                            <i className="bi bi-circle-fill me-1"></i>
                            Very Active
                          </div>
                          <div className="text-muted jobcard-location-alljobs" >
                            <i className="bi bi-eye-fill me-1"></i>
                            {job.view_count || 0} views
                          </div> */}

                                                    {/* Add the Message button here */}
                                                    <button
                                                        className="btn btn-outline-primary btn-sm ms-2 message-button-viewjobs"
                                                        onClick={(e) => handleMessageClick(job, e)}
                                                        style={{
                                                            padding: '2px 8px',
                                                            fontSize: '14px',
                                                            border: '1px solid #0d6efd',
                                                            color: '#0d6efd',
                                                            borderRadius: '0px',
                                                            marginTop: '6px',
                                                            backgroundColor: 'transparent'
                                                        }}
                                                    >
                                                        <i className="bi bi-chat-dots me-1"></i>
                                                        <span>Message</span>
                                                    </button>
                                                    <button
                                                        className="btn btn-outline-primary btn-sm ms-2 message-button-viewjobs"
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            handleJobClick(job);
                                                        }}
                                                        style={{
                                                            padding: '2px 8px',
                                                            fontSize: '14px',
                                                            border: '1px solid #0d6efd',
                                                            color: '#0d6efd',
                                                            borderRadius: '0px',
                                                            marginTop: '6px',
                                                            backgroundColor: 'transparent'
                                                        }}
                                                    >
                                                        <i className="bi bi-eye me-1"></i>
                                                        <span>View</span>
                                                    </button>
                                                    <button
                                                        className="btn btn-success btn-sm ms-2 message-button-viewjobs"
                                                        onClick={(e) => handleApplyClick(job, e)}
                                                        style={{
                                                            padding: '2px 8px',
                                                            fontSize: '14px',
                                                            borderRadius: '0px',
                                                            marginTop: '6px'
                                                        }}
                                                    >
                                                        <i className="bi bi-check-circle me-1"></i>
                                                        <span>Apply</span>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            {loadingMore && (
                                <div className="text-center mt-3">
                                    <div className="spinner-border spinner-border-sm text-primary" role="status">
                                        <span className="visually-hidden">Loading...</span>
                                    </div>
                                </div>
                            )}
                                {!loadingMore && (visibleCount < filteredJobs.length || hasMore) && (
                                    <div className="text-center mt-4 mb-3">
                                        <button
                                            className="load-more-btn"
                                            onClick={handleLoadMore}
                                        >
                                            Load More
                                        </button>
                                    </div>
                                )}
                            </>
                        )}
                    </div>
                </div>
            </div>
            <GulfWorkerLeadBot pageContext="Jobs in Europe" />
            <Footer />
        </>
    );
}

export default EuropeanJobs;
